import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	bases: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	base: { error: null, loading: false, data: null },
	editedBase: { error: null, loading: false, data: null },
	removedBase: { error: null, loading: false, data: null },
	createdBase: { error: null, loading: false, data: null },
	// VaiFacil integration:
	ordersVaiFacil: { error: null, loading: false, data: [] },
	dispatchList: [],
	dispatchedOrdersVaiFacil: { error: null, loading: false, data: {} },
	//itemsSelected: [],
};

const { actions, reducer } = createSlice({
	name: 'bases',
	initialState,
	reducers: {
		getBases: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.bases = {
				...state.bases,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getBasesFailure: (state, { payload }) => {
			state.bases = {
				...state.bases,
				error: payload,
				loading: false,
			};
		},
		getBasesSuccess: (state, { payload }) => {
			state.bases = {
				...state.bases,
				data: payload.body,
				totalCount: payload.meta?.totalCount ?? payload.body.length,
				error: null,
				loading: false,
			};
		},
		getBaseById: (state, { payload }) => {
			state.base = {
				...state.base,
				data: null,
				error: null,
				loading: true,
			};
		},
		getBaseByIdFailure: (state, { payload }) => {
			state.base = {
				...state.base,
				error: payload,
				loading: false,
			};
		},
		getBaseByIdSuccess: (state, { payload }) => {
			state.base = {
				...state.base,
				data: payload,
				error: null,
				loading: false,
			};
		},
		createBase: (state, { payload }) => {
			state.createdBase = {
				...state.createdBase,
				data: null,
				error: null,
				loading: true,
			};
		},
		createBaseFailure: (state, { payload }) => {
			state.createdBase = {
				...state.createdBase,
				error: payload,
				loading: false,
			};
		},
		createBaseSuccess: (state, { payload }) => {
			state.createdBase = {
				...state.createdBase,
				data: payload,
				error: null,
				loading: false,
			};
		},
		updateBase: (state, { payload }) => {
			state.editedBase = {
				...state.editedBase,
				data: null,
				error: null,
				loading: true,
			};
		},
		updateBaseFailure: (state, { payload }) => {
			state.editedBase = {
				...state.editedBase,
				error: payload,
				loading: false,
			};
		},
		updateBaseSuccess: (state, { payload }) => {
			state.editedBase = {
				...state.editedBase,
				data: payload,
				error: null,
				loading: false,
			};
		},
		removeBase: (state, { payload }) => {
			state.removedBase = {
				...state.removedBase,
				data: null,
				error: null,
				loading: true,
			};
		},
		removeBaseFailure: (state, { payload }) => {
			state.removedBase = {
				...state.removedBase,
				error: payload,
				loading: false,
			};
		},
		removeBaseSuccess: (state, { payload }) => {
			state.removedBase = {
				...state.removedBase,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getOrdersVaiFacil: (state, { payload }) => {
			state.ordersVaiFacil = {
				...state.ordersVaiFacil,
				error: null,
				loading: true,
			};
		},
		getOrdersVaiFacilFailure: (state, { payload }) => {
			state.ordersVaiFacil = {
				...state.ordersVaiFacil,
				error: payload,
				loading: false,
			};
		},
		getOrdersVaiFacilSuccess: (state, { payload }) => {
			state.ordersVaiFacil = {
				...state.ordersVaiFacil,
				data: payload,
				error: null,
				loading: false,
			};
		},
		dispatchOrdersVaiFacil: (state, { payload }) => {
			state.dispatchedOrdersVaiFacil = {
				//...state.dispatchedOrdersVaiFacil,
				data: {},
				error: null,
				loading: true,
			};
		},
		dispatchOrdersVaiFacilFailure: (state, { payload }) => {
			state.dispatchedOrdersVaiFacil = {
				...state.dispatchedOrdersVaiFacil,
				error: payload,
				loading: false,
			};
		},
		dispatchOrdersVaiFacilSuccess: (state, { payload }) => {
			state.dispatchedOrdersVaiFacil = {
				...state.dispatchedOrdersVaiFacil,
				data: payload,
				error: null,
				loading: false,
			};
		},
		addDispatchItem: (state, { payload }) => {
			state.dispatchList = [...state.dispatchList, { ...payload, id: state.dispatchList.length }];
		},
		addDispatchItems: (state, { payload }) => {
			payload.forEach((item) => {
				state.dispatchList.push({ ...item, id: state.dispatchList.length });
			});
		},
		resetDispatchList: (state, { payload }) => {
			state.dispatchList = [];
		},
		removeDispatchItem: (state, { payload }) => {
			state.dispatchList = state.dispatchList.filter((item) => item.id !== payload.id);
		},
		removeDispatchItemsByCodes: (state, { payload }) => {
			state.dispatchList = state.dispatchList.filter(
				(item) => !payload.includes(item.trackingCode),
			);
		},
	},
});

export const {
	getBases,
	getBasesSuccess,
	getBasesFailure,
	getBaseById,
	getBaseByIdSuccess,
	getBaseByIdFailure,
	createBase,
	createBaseFailure,
	createBaseSuccess,
	updateBase,
	updateBaseFailure,
	updateBaseSuccess,
	removeBase,
	removeBaseFailure,
	removeBaseSuccess,
	getOrdersVaiFacil,
	getOrdersVaiFacilFailure,
	getOrdersVaiFacilSuccess,
	dispatchOrdersVaiFacil,
	dispatchOrdersVaiFacilFailure,
	dispatchOrdersVaiFacilSuccess,
	addDispatchItem,
	addDispatchItems,
	resetDispatchList,
	removeDispatchItem,
	removeDispatchItemsByCodes,
} = actions;

export { default as basesSaga } from './sagas';

export default reducer;
